export enum EnumAuthProviderType {
  Http = "Http",
  Jwt = "Jwt",
  Auth0 = "Auth0",
}
